import axios from "axios";
import {Message} from "tsa-ui";

var baseURL= '/content/api/';
let duration = 2 * 1000;

const service = axios.create({
    baseURL,
    timeout: 86400000,
    headers: {}
});


service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        const {status, data} = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            Message({
                message: data.message || "Error",
                type: "error",
                duration
            });
            return false;
        } else {
            return data
        }
    },
    error => {
        if (error.response?.data) {
            return Promise.reject(error.response.data);
        } else {
            return Promise.reject(error.response);
        }

    }
);

export default service;